/**
 * ZD-3331 : 메일 창 발신 주소 후보 목록.
 * - 기본 주소(email_address)는 형식 판정 없이 항상 첫 후보다. 지금 발송에 쓰는 값이므로 기본 선택값이 바뀌지 않는다.
 * - 추가 주소(email_address_extra)는 쉼표로 나눠 trim 하고 빈 항목만 뺀다.
 * - 주소 형식으로는 거르지 않는다. 형식 판정은 서버만 한다('+' 주소 등 서버가 받는 주소를 화면에서 빼지 않기 위해).
 * - 대소문자 무시로 중복을 빼고 먼저 나온 표기를 남긴다.
 */
export function buildSendAddressList(default_value, extra_value) {
	const address_list = [];
	const pushUnique = value => {
		const address = value == null ? '' : String(value).trim();
		if (!address) return;
		if (address_list.some(e => e.toLowerCase() === address.toLowerCase())) return;
		address_list.push(address);
	};

	pushUnique(default_value);
	const extra_list = extra_value == null ? [] : String(extra_value).split(',');
	extra_list.forEach(pushUnique);
	return address_list;
}
